/**
 * Contrato Spatial UX Pipeline — Valuation Enterprise (RQ-040B).
 * Referência UX: pesquisa eEmovel (evidência, sem clone de marca).
 */

export const SPATIAL_UX_VERSION = "valuation-automatic-spatial-ux-v1";

export const RADIUS_STEP_M = 50;
export const RADIUS_MIN_M = 50;
export const RADIUS_MAX_M = 5000;
export const DEFAULT_RADIUS_M = 500;

/** Estados canónicos do comparável no mapa/lista */
export const COMPARABLE_VISUAL_STATES = Object.freeze({
  FOUND: "FOUND",
  ELIGIBLE: "ELIGIBLE",
  SELECTED: "SELECTED",
  EXCLUDED_MANUAL: "EXCLUDED_MANUAL",
  DISCARDED_FILTER: "DISCARDED_FILTER",
  DISCARDED_OUTLIER: "DISCARDED_OUTLIER",
  USED_IN_REGRESSION: "USED_IN_REGRESSION",
  STALE: "STALE",
  INVALID: "INVALID",
  MISSING_DATA: "MISSING_DATA"
});

export const SPATIAL_LAYER_KEYS = Object.freeze({
  subject: "subject",
  influence: "influence",
  comparables: "comparables",
  clusters: "clusters",
  excluded: "excluded",
  ibge: "ibge",
  pois: "pois",
  bairros: "bairros",
  heatmap: "heatmap"
});

export const DEFAULT_SPATIAL_LAYERS = Object.freeze({
  subject: true,
  influence: true,
  comparables: true,
  clusters: true,
  excluded: true,
  ibge: false,
  pois: false,
  bairros: false,
  heatmap: false
});

export const SPATIAL_STEP_META = Object.freeze([
  { id: 1, label: "Solicitação", cta: "Continuar", short: "Pedido e documentos" },
  { id: 2, label: "Endereço", cta: "Localizar imóvel", short: "Endereço, número e CEP" },
  { id: 3, label: "Localização no mapa", cta: "Continuar", short: "Pino, precisão e atributos" },
  { id: 4, label: "Comparáveis", cta: "Avaliar", short: "Busca, amostra e revisão" },
  { id: 5, label: "Enriquecimento", cta: "Continuar", short: "Fachada, região e notas" },
  { id: 6, label: "Modelagem", cta: "Continuar", short: "Cálculo do valor" },
  { id: 7, label: "Resultado", cta: "Ver relatórios", short: "Valor e alertas" },
  { id: 8, label: "Relatórios", cta: "Finalizar avaliação", short: "Laudos e exportações" }
]);

export function clampRadiusM(raw) {
  const n = Math.round(Number(raw) || DEFAULT_RADIUS_M);
  const stepped = Math.round(n / RADIUS_STEP_M) * RADIUS_STEP_M;
  return Math.min(RADIUS_MAX_M, Math.max(RADIUS_MIN_M, stepped));
}

export function emptySpatialCounts() {
  return {
    encontrados: 0,
    dentro_area: 0,
    elegiveis: 0,
    selecionados: 0,
    excluidos: 0,
    descartados: 0,
    usados_regressao: 0,
    clusters_visiveis: 0
  };
}
